import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SearchSchema } from './-schema';
export const Route = createFileRoute('/_staff/software/$id/_$id/settings/role/')({
  validateSearch: zodValidator(SearchSchema)
});